import { ContextStore } from 'bernie-plugin-mobx';
import { getStaticConfig } from 'config/static-config';

export interface ITimeFramesFormat {
  value: string;
  label: string;
}

const timeFrames: ITimeFramesFormat[] = [];

export const timeFramesList = (
  context: ContextStore,
  formatText: (key: string, ...args: any[]) => string
): ITimeFramesFormat[] => {
  if (timeFrames.length === 0) {
    const interval = 15;
    let startingTime = 0;
    const AMPM = ['AM', 'PM'];
    const use12HrFormat = getStaticConfig(context.site.id).changeSearch.timeDropdown12Hr;

    while (startingTime < 24 * 60) {
      const hourRaw = Math.floor(startingTime / 60); // hours of day in 0-24 format

      const hourValue = `${hourRaw % 12 === 0 ? 12 : hourRaw % 12}`;
      const minuteValue = ('0' + (startingTime % 60)).slice(-2);
      const AMPMValue = AMPM[Math.floor(hourRaw / 12)];
      const value = `${hourValue}${minuteValue}${AMPMValue}`;

      timeFrames.push({
        value,
        label : formatText(buildTimeDropdownOptionLocKey(value, use12HrFormat))
      });

      startingTime += interval;
    }
  }

  return timeFrames;
};

const buildTimeDropdownOptionLocKey = (value: string, is12Hr: boolean) =>
  `time.dropdown.${value}${is12Hr ? '12hr' : ''}.text`;
